import { Factory } from '..'
import { UnlockPriceType } from './unlock-price'
import {
  applyEntitySchema,
  objectSchema,
  openUnion,
  optionalTolerant,
  parseEntity,
  sourceJson,
} from '../../_utils/fcdc-v2'
import * as z from 'zod'

const UnlocksSchema = openUnion('type', {
  [UnlockPriceType.Limited]: objectSchema({
    type: z.literal(UnlockPriceType.Limited),
    purchased: optionalTolerant(z.number()),
    used: optionalTolerant(z.number()),
  }),
  [UnlockPriceType.Unlimited]: objectSchema({
    type: z.literal(UnlockPriceType.Unlimited),
    used: optionalTolerant(z.number()),
  }),
})

export abstract class Unlocks {
  type: UnlockPriceType

  protected constructor(json: unknown, type: UnlockPriceType) {
    this.type = type
    applyEntitySchema(this, UnlocksSchema, sourceJson(json), {})
  }

  public static getFactory(): Factory<Unlocks> {
    return new (class implements Factory<Unlocks> {
      make(json: any): Unlocks {
        switch (json?.type) {
          case UnlockPriceType.Limited:
            return new LimitedUnlocks(json)
          case UnlockPriceType.Unlimited:
            return new UnlimitedUnlocks(json)
          default:
            return parseEntity(UnlocksSchema, json ?? {}) as Unlocks
        }
      }

      getTableName(): string {
        throw new Error(
          'getTableName() should never be called on Unlocks. Unlocks are not stored in IndexDB.'
        )
      }
    })()
  }
}

export class LimitedUnlocks extends Unlocks {
  purchased: number
  used: number

  constructor(json: any) {
    const source = sourceJson(json) as any
    super(source, UnlockPriceType.Limited)
    this.purchased = source.purchased
    this.used = source.used
  }
}

export class UnlimitedUnlocks extends Unlocks {
  used: number

  constructor(json: any) {
    const source = sourceJson(json) as any
    super(source, UnlockPriceType.Unlimited)
    this.used = source.used
  }
}
